import { Component } from '@angular/core';
import {OrdersSuccessData} from "../../../../interfaces/orders-success-data";

@Component({
  selector: 'app-message-delivery-dl-confirm',
  templateUrl: './message-delivery-dl-confirm.component.html',
  styleUrls: ['./message-delivery-dl-confirm.component.scss']
})
export class MessageDeliveryDLConfirmComponent {

  public data: OrdersSuccessData;

  public isDeliveryDLConfirmation: boolean = false;
  deliveryDLConfirmationShow(data: OrdersSuccessData) {
    this.data = data;
    this.isDeliveryDLConfirmation = true;
  }

    protected readonly parseFloat = parseFloat;
}
